import React, { useState } from 'react';
import withComponentAuth from '../hoc/withComponentAuth';
import { Box } from '@mui/material';
import { SmartFilter } from '../components/common/SmartFilter';
import { CreateTableHeader } from '../components/common/TableHeader';
import { IZone } from '../utils/entities/interface';
import Pagination from '../components/atoms/Pagination';
import { headerZonesTable } from '../utils/constants';
import { ZoneList } from '../components/ui/list/Zones';

const Zones: IZone[] = Array.from({ length: 100 }, (_, index) => {
  const pincodesCount = Math.floor(Math.random() * 46) + 5;
  const randomPincodes = Array.from(
    { length: pincodesCount },
    () => Math.floor(Math.random() * 900000) + 100000,
  );
  return {
    id: index + 1,
    name: `Zone ${index}`,
    pincodes: randomPincodes,
    isDisabled: index % 2 === 0,
  };
});

const ZonesManagement = () => {
  const [page, setPage] = useState<number>(0);
  const [rowsPerPage, setRowsPerPage] = useState<number>(25);

  const paginatedZones = Zones.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage,
  );

  const handleSaveRefresh = () => {
    console.log('SAVED');
  };

  const handleFilterRefresh = () => {
    console.log('FILTER HAPPENED');
  };

  const handleChangePage = (event: any, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: any) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          maxHeight: '100%',
        }}
      >
        <SmartFilter
          createFilter={[
            'SEARCH',
            'FILTER',
            'SORT',
            'ADD',
            'EXPORT',
            'DELETE',
          ]}
          // filter={<UserFilter />}
          // addElement={<CreateTechnician />}
          addDrawerSize="sm"
          filterdrawerSize="md"
          filterHeader={'Filter Zones'}
          addHeader={'Add Zones'}
          onSaved={handleSaveRefresh}
          onFiltered={handleFilterRefresh}
        />

        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            flex: 1,
            minHeight: 0,
            p: 1,
          }}
        >
          <CreateTableHeader tableCell={headerZonesTable} />

          <Box
            sx={{
              height: '100%',
              maxHeight: '100%',
              overflowY: 'scroll',
              scrollbarWidth: 'none',
            }}
          >
            <ZoneList zones={paginatedZones} />
          </Box>

          <Box display={'block'} bottom={0} right={0}>
            <Pagination
              count={Zones.length}
              page={page}
              rowsPerPage={rowsPerPage}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default withComponentAuth(ZonesManagement);
